import { SEARCH_PARAMS } from '@/constants/search-params'

/**
 * Builds a redirect path with auth message query parameter
 */
export const buildAuthRedirectPath = (
  message: string,
  basePath = '/auth/signin',
): string => {
  const searchParams = new URLSearchParams()
  searchParams.set(SEARCH_PARAMS.authMessage, message)
  return `${basePath}?${searchParams.toString()}`
}

/**
 * Builds redirect path for IP mismatch scenario
 */
export const buildIpMismatchRedirectPath = (): string => {
  return buildAuthRedirectPath('ip-mismatch')
}
